<div>
	<div class="row col-12">
		<h1 class="h3 m-4">{{ 'site_performance.daily_battery_usage_metrics' | translate }}</h1>
	</div>

	<div class="row col-xl-12 mb-4" *ngIf="!userParentFilters">
		<div class="col-xl-4 col-md-4">
			<div class="input-group">
				<div class="input-group-prepend">
					<span class="input-group-text">{{'g.start_date' | translate}}</span>
				</div>
				<input type="text" class="form-control" placeholder="mm/dd/yyyy" name="dp1" (ngModelChange)="changeDate('fromDate', $event)" [(ngModel)]="fromDate" bsDatepicker #d1="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}" [maxDate]="toDate" [minDate]="siteInstallationDate">
				<div class="input-group-append pointer" (click)="d1.toggle()">
					<span class="input-group-text"><i class="fa fa-calendar"></i></span>
				</div>
			</div>
		</div>

		<div class="col-xl-4 col-md-4">
			<div class="input-group">
				<div class="input-group-prepend">
					<span class="input-group-text">{{'g.end_date' | translate}}</span>
				</div>
				<input type="text" class="form-control" placeholder="mm/dd/yyyy" name="dp2" (ngModelChange)="changeDate('toDate', $event)" [(ngModel)]="toDate" bsDatepicker #d2="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}" [minDate]="fromDate">
				<div class="input-group-append pointer" (click)="d2.toggle()">
					<span class="input-group-text"><i class="fa fa-calendar"></i></span>
				</div>
			</div>
		</div>
	</div>

	<div class="row col-xl-12 mb-4" *ngIf="!userParentFilters">
		<!-- voltage filter -->
		<div class="col-sm-6 col-md-4 col-lg-4">
			<label for="batteryVoltageSelect">{{"fleet_reports.battery_voltage" | translate}}</label>
			<ng-select
				id="batteryVoltageSelect"
				class="select"
				[items]="batteryVoltagesOptions"
				[addTag]="false"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				(change)="onSelectionChanged({filter: 'voltageFilter', value: $event.value})"
				[placeholder]="'qv.voltage' | translate"
				[(ngModel)]="selectedBatteryVoltage"
			></ng-select>
		</div>

		<!-- capacity filter -->
		<div class="col-sm-6 col-md-4 col-lg-4">
			<label for="batteryCapacitySelect">{{"devices.battery_capacity" | translate}}</label>
			<ng-select
				id="batteryCapacitySelect"
				class="select"
				[items]="batteryCapacitiesOptions"
				[addTag]="false"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				(change)="onSelectionChanged({filter: 'capacityFilter', value: $event.value})"
				[placeholder]="'qv.capacity' | translate"
				[(ngModel)]="selectedBatteryCapacity"
			></ng-select>
		</div>
	</div>

	<div class="metrics-row py-4" *ngIf="!noData;">
		<app-utilization-metric-box
			class="ml-2"
			[title]="'exception_reports.average_daily_hours_usage' | translate"
			[icon]="'fa fa-clock-o'"
			[items]="assetUtilization">
		</app-utilization-metric-box>
		<app-utilization-metric-box
			[title]="'exception_reports.average_daily_ahrs_usage' | translate"
			[icon]="'fa fa-bolt'"
			[theme]="'green'"
			[items]="maintenance">
		</app-utilization-metric-box>
		<app-utilization-metric-box
			*ngIf="showFastOpportunityWidget"
			class="mr-2"
			[title]="'exception_reports.opportunity_fast_charging' | translate"
			[icon]="'fa fa-warning'"
			[theme]="'purple'"
			[items]="charging">
		</app-utilization-metric-box>
	</div>
	
	<!-- Legend Section -->
	<div class="legend-section" *ngIf="!noData;">
		<div class="legend-container">
			<div class="legend-title">{{ 'battery_performance.legend' | translate }}</div>
			<div class="legend-groups">
				<div class="legend-group" *ngFor="let group of batteryDailyAvgUsageLegends">
					<div class="legend-group-title">{{ group.title }}</div>
					<div class="legend-item" *ngFor="let item of group.items">
						<span
							class="legend-symbol"
							[ngClass]="[
								item.type || 'dot',
								item.severity || item.colorClass
							]"
						></span>
						<span class="legend-label">{{ item.label }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="card-body" *ngIf="noData">
	<div class="alert alert-info">{{'g.no_data_to_show' | translate}}</div>
</div>
